import { Component, ViewChild,AfterViewInit,ElementRef,Output,EventEmitter,Input} from '@angular/core';
import {MediaService} from '../peers/media.service';
import {Modal} from 'ng2-modal';
declare var $;
import {SessionManagerService} from '../services/session/session-manager.service';
@Component({
  selector: "dskl-tools-sessions",
  templateUrl: 'sessions.component.html',
  
})

export class SessionsComponent {

  constructor(public sessionManager: SessionManagerService){}
  @ViewChild("sessionsModal") sessionsModal: Modal;
 
  open(){
    
    this.sessionsModal.open();
    this.sessionManager.getSessions();
    console.log("Opening");
  }

 }


// WEBPACK FOOTER //
// /app/src/app/wb/tools/sessions.component.ts